module.exports = __webpack_public_path__ + "img/benefits1.dde77ffc.png";